// Trademark-safe neon cover art for each classic, generated via Workers AI
// (scripts/generate-classics-covers.mjs) and served from
// public/preview-assets/classics/. Keyed by the classic `id` in
// src/shared/classics-catalog.ts. Every cover avoids the source game's
// protected/recognizable elements (see scripts/lib/classics-prompts.mjs).
export const classicImages: Record<string, string> = {
  doom: "/preview-assets/classics/doom.jpg",
  "2048": "/preview-assets/classics/2048.jpg",
  breakout: "/preview-assets/classics/breakout.jpg",
  snake: "/preview-assets/classics/snake.jpg",
  asteroids: "/preview-assets/classics/asteroids.jpg",
  "space-invaders": "/preview-assets/classics/space-invaders.jpg",
  pong: "/preview-assets/classics/pong.jpg",
  "pac-man": "/preview-assets/classics/pac-man.jpg",
  galaga: "/preview-assets/classics/galaga.jpg",
  frogger: "/preview-assets/classics/frogger.jpg",
  hextris: "/preview-assets/classics/hextris.jpg",
  skifree: "/preview-assets/classics/skifree.jpg",
  "duck-hunt": "/preview-assets/classics/duck-hunt.jpg",
  sokoban: "/preview-assets/classics/sokoban.jpg",
  minesweeper: "/preview-assets/classics/minesweeper.jpg",
  tempest: "/preview-assets/classics/tempest.jpg",
  qix: "/preview-assets/classics/qix.jpg",
  hexgl: "/preview-assets/classics/hexgl.jpg",
  outrun: "/preview-assets/classics/outrun.jpg",
  kurve: "/preview-assets/classics/kurve.jpg",
  "connect-four": "/preview-assets/classics/connect-four.jpg",
  mahjong: "/preview-assets/classics/mahjong.jpg",
  digger: "/preview-assets/classics/digger.jpg",
  "breakout-vs": "/preview-assets/classics/breakout-vs.jpg",
  "missile-command": "/preview-assets/classics/missile-command.jpg",
  arkanoid: "/preview-assets/classics/arkanoid.jpg",
  "a-dark-room": "/preview-assets/classics/a-dark-room.jpg",
  rogue: "/preview-assets/classics/rogue.jpg",
  openlara: "/preview-assets/classics/openlara.jpg",
  mario: "/preview-assets/classics/mario.jpg",
};
